// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "onboarding-driver" + "." + "bf784dd7" + ".chunk.css";
};